<template>

<v-card flat>
  <request-status :request='requests.get' :message200='false' />
  <v-card-title class='subtitle-1 overline py-0 grey lighten-4' >
    {{title}}
    <v-spacer></v-spacer>
    <v-btn @click='$emit("close")' icon small ><v-icon small >close</v-icon></v-btn>
  </v-card-title>
  <v-alert type='info' :value='true' class='ma-0 lighten-2' dismissible dense >
    Below is a list of submissions which could not be automatically assigned to a client.
    Choose "assign" next to the submission/s you would like to set for this client
  </v-alert>
  <request-status
    :request='requests.assign'
    :message200='false'
    @ok='assignSuccess' />
  <v-list class='pa-0'>
    <v-subheader class='overline' >Unlinked submissions
      <v-spacer/>
      <v-btn @click='get' :loading='requests.get.loading' small icon ><v-icon small >replay</v-icon></v-btn>
    </v-subheader>
    <v-divider/>
    <div v-if='!requests.get.loading && submissions && submissions.length === 0' class='pa-3' >
      Couldn't find any unlinked sumissions
    </div>
    <submission-list-item
      v-for='sub in submissions'
      :key="sub.id"
      :item='sub'
      :with-actions='false' >

      <v-list-tile-action slot='list-tile-action' >
        <v-btn @click.stop='assign(sub)' small outline >
          Assign
        </v-btn>
      </v-list-tile-action>
    </submission-list-item>
  </v-list>
  <slot name='card-actions' ></slot>
  <!-- <pre v-text='req' /> -->
</v-card>

</template>
<script>
import SubmissionListItem from '@/components/listitems/SubmissionListItem'

export default {
  name: 'AssignSubmission',
  components: { SubmissionListItem },
  props: {
    relationshipId: { required: true },
    title: { type: String, default: 'Choose a submission to link' }
  },
  data () {
    return {
      window: 0,
      requests: {
        get: {
          resource: 'ag.integrations',
          params: { unlinked: true },
          extra: 'jotform/submissions'
        },
        assign: {
          resource: 'ag.integrations',
          extra: 'jotform/assign_submission'
        }
      }
    }
  },
  mounted () {
    this.get()
  },
  computed: {
    submissions () {
      return this.getObjectPath(this.requests.get, 'result', [])
    }
  },
  methods: {
    get () {
      this.$request('get', this.requests.get)
    },
    assign (submission) {
      this.requests.assign.data = {
        relationship_id: this.relationshipId,
        submission_id: submission.submission_id,
        form_id: submission.form
      }
      this.requests.assign.method = 'post'
      this.$request('save', this.requests.assign)
    },
    assignSuccess (result) {
      this.get()
      this.$emit('ok', result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignSubmission.vue?8a9c0b72